import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { listClassification, listGender } from "../../../../../../../data/list";
const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CURRENCY, NUMBER, DATE_PRE } =
  FIELD_TYPE;
const TEL_NUMBER_REGEX = /^\d+$/;
const listMarriage = [
  {
    value: "0",
    label: "Chưa kết hôn",
  },
  {
    value: "1",
    label: "Sống chung chưa kết hôn",
  },
];
const dataSoYeuLyLich: DataFormField[] = [
  {
    type: INPUT,
    label: "Sơ yếu lý lịch có chứng nhận của phường/xã",
    name: "fileSoYeuLyLichChungNhanPhuongX",
    disable: true,
    //rules: [{required: true, message: "Chưa nhập đợt tuyển dụng"}],
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
const dataLyLichTuPhap: DataFormField[] = [
  {
    type: INPUT,
    name: "fileLyLichTuP",
    label: "Lý lịch tư pháp ",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
const dataGiayKhaiSinh: DataFormField[] = [
  {
    type: INPUT,
    name: "fileGiayKhaiS",
    label: "Giấy khai sinh",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
    //rules: [{required: true, message: "Chưa nhập họ và tên"}],
  },
]
const dataGiayKhamSucKhoe: DataFormField[] = [
  {
    type: INPUT,
    name: "fileGiayKhamSucK",
    label: "Giấy khám sức khỏe",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
    // disableDate:false,
    // optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
]
const dataTheCanCuoc: DataFormField[] = [
  {
    type: INPUT,
    name: "fileCMNDCMTCongC",
    label: "CCCD/CMT công chứng",
    disable: true,
    //options: listGender,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
const dataXacNhanThuongChu: DataFormField[] = [
  {
    type: INPUT,
    name: "fileGiayXacNhanThuongTruCuaCA",
    label: "Giấy xác nhận thường trú của công an",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
const dataBangCap: DataFormField[] = [
  {
    type: INPUT,
    name: "fileBangC",
    label: "Bằng cấp",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
const dataXacNhanTienAn: DataFormField[] = [
  {
    type: INPUT,
    name: "fileXacNhanCongAnKhongTienAnTienS",
    label: "Xác nhận công an không tiền án,tiền sự",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
const dataKhaiSinhCon: DataFormField[] = [
  {
    type: INPUT,
    name: "fileGiayKhaiSinhC",
    label: "Giấy khai sinh con(nếu có)",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
const dataChungChiHanhNghe: DataFormField[] = [
  {
    type: INPUT,
    name: "fileChungChiHanhN",
    label: "Chứng chỉ hành nghề",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
const dataNghiHuu: DataFormField[] = [
  {
    type: INPUT,
    name: "fileQuyetDinhNghiViecNghi",
    label: "Quyết định nghỉ việc/hoặc nghỉ hưu",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
const dataKhac: DataFormField[] = [
  {
    type: INPUT,
    name: "fileKh",
    label: "Khác",
    disable: true,
    css: {
      xl: 21,
      lg: 21,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 7, xl:7 },
    wrapperCol: { xs: 14, md: 16, lg: 17, xl: 17 },
  },
]
export { dataSoYeuLyLich,dataLyLichTuPhap,dataGiayKhaiSinh,dataGiayKhamSucKhoe,dataTheCanCuoc,
  dataXacNhanThuongChu,dataBangCap,dataXacNhanTienAn,dataKhaiSinhCon,dataChungChiHanhNghe,dataNghiHuu,dataKhac };
